import Vue from 'vue'
import VueRouter from 'vue-router'
// import store from "@/store";

Vue.use(VueRouter)

var routes = [
 
  // {
  //   path: '/Login',
  //   name: 'Login',
  //   component: () => import('../views/Login'),
  //   children:[
  //     {
  //       path:'test',
  //       component:() => import('../views/test'),
  //     }
  //   ]
  // },
  // {
  //   path: '/register',
  //   name: 'Register',
  //   component: () => import('../views/register')
  // },{
  //   path: '/home',
  //   name: 'Register',
  //   component: () => import('../components/home')
  // },{
  //   path: '/person',
  //   name: 'person',

  //   component: () => import('../views/person')
  // },{
  //   path: '/user',
  //   name: 'user',
  //   component: () => import('../views/user')
  // },{
  //   path: '/homepage',
  //   name: 'user',
  //   component: () => import('../views/homepage')
  // },{
  //   path: '/changed',
  //   name: 'changed',
  //   component: () => import('../views/changepwd')
  // }
    {
    path: '/regist',
    name: 'regist',
    // meta:{ authRequired:true },
    component: () => import('../views/regitst.vue')
    },
    {
      path: '/',
      name: 'home',
      // component: () => import('../views/pageHome.vue'),
      component: () => import('../views/regitst.vue'),
      //  改为这个为直接打开首页跳转到 注册页面    
    },
    {
      path: '/page',
      name: 'page',
      component: () => import('../views/newPage.vue'),
    },
    {
      path: '/page1',
      name: 'page1',
      component: () => import('../views/newPage1.vue'),
    },
    {
      path: '/page2',
      name: 'page2',
      component: () => import('../views/newPage2.vue'),
    },
    {
      path: '/page3',
      name: 'page3',
      component: () => import('../views/newPage3.vue'),
    },
    {
      path: '/page4',
      name: 'page4',
      component: () => import('../views/newPage4.vue'),
    },
    {
      path: '/page5',
      name: 'page5',
      component: () => import('../views/newPage5.vue'),
    },

    {
      path: '/page6',
      name: 'page6',
      component: () => import('../views/newPage6.vue'),
    },
    {
      path: '/page7',
      name: 'page7',
      component: () => import('../views/newPage7.vue'),
    },
    {
      path: '/page8',
      name: 'page8',
      component: () => import('../views/newPage8.vue'),
    },
  // {
  //   path: '/maven',
  //   name: 'maven',
  //   // meta:{ authRequired:true },
  //   component: () => import('../views/maven')
  // },
  // {
  //   path: '/regist',
  //   name: 'maven',
  //   // meta:{ authRequired:true },
  //   component: () => import('../views/Study/test')
  // },
  // {
  //   path: '/index',
  //   name: 'maven',
  //   // meta:{ authRequired:true },
  //   component: () => import('../views/mannage/index')
  // },

]

// const router = new VueRouter({
//   mode: 'history',
//   base: process.env.BASE_URL,
//   routes
// })
//
// // 提供一个重置路由的方法
// export const resetRouter = () => {
//   router.matcher = new VueRouter({
//     mode: 'history',
//     base: process.env.BASE_URL,
//     routes
//   })
// }
//
// // 注意：刷新页面会导致页面路由重置
// export const setRoutes = () => {
//   const storeMenus = localStorage.getItem("menus");
//   if (storeMenus) {
//
//     // 获取当前的路由对象名称数组
//     const currentRouteNames = router.getRoutes().map(v => v.name)
//     if (!currentRouteNames.includes('Manage')) {
//       // 拼装动态路由
//       const manageRoute = { path: '/', name: 'Manage', component: () => import('../views/Manage.vue'), redirect: "/home", children: [
//           { path: 'person', name: '个人信息', component: () => import('../views/Person.vue')},
//           { path: 'password', name: '修改密码', component: () => import('../views/Password.vue')}
//         ] }
//       const menus = JSON.parse(storeMenus)
//       menus.forEach(item => {
//         if (item.path) {  // 当且仅当path不为空的时候才去设置路由
//           let itemMenu = { path: item.path.replace("/", ""), name: item.name, component: () => import('../views/' + item.pagePath + '.vue')}
//           manageRoute.children.push(itemMenu)
//         } else if(item.children.length) {
//           item.children.forEach(item => {
//             if (item.path) {
//               let itemMenu = { path: item.path.replace("/", ""), name: item.name, component: () => import('../views/' + item.pagePath + '.vue')}
//               manageRoute.children.push(itemMenu)
//             }
//           })
//         }
//       })
//       // 动态添加到现在的路由对象中去
//       router.addRoute(manageRoute)
//     }
//
//   }
// }
//
// // 重置我就再set一次路由
// setRoutes()
//
//
// router.beforeEach((to, from, next) => {
//   localStorage.setItem("currentPathName", to.name)  // 设置当前的路由名称
//   store.commit("setPath")
//
//   // 未找到路由的情况
//   if (!to.matched.length) {
//     const storeMenus = localStorage.getItem("menus")
//     if (storeMenus) {
//       next("/404")
//     } else {
//       // 跳回登录页面
//       next("/login")
//     }
//   }
//   // 其他的情况都放行
//   next()
//
// })
//创建一个路由器
const router = new VueRouter({
    base: '/',// 配置单页应用的基路径,我的理解就是访问这个地址的时候开始是/，根据路由时/跳转到登录页面
    routes
})

//全局前置路由守卫 切换之前调用这个方法
//to 目标路由
// router.beforeEach((to, from, next)=>{
//   const token=localStorage.getItem('user')
//   if((to.name!=='Login') && !token) next({name:'Login'})
//   else next()
// })

export default router
